import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import {
  AUTH_HEADER,
  SECURE_BASE_URL_KEY,
  SECURE_AUTH_TOKEN_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { RemoteAddTourDeviation } from "../../../data/usecases/tour-deviation-report/remote-add-tour-deviation";
import Endpoints from "../../../domain/endpoints";
import { addUserTourDeviation } from "../../../domain/useages/tour-deviation-report/add-user-tour-deviation";
import { RemoteAddUserTourDeviation } from "../../../data/usecases/tour-deviation-report/remote-add-user-tour-deviation";

export interface addUserTourDeviationInterface {
  addUserTourDeviation: Function;
  addUserTourDeviationState: FetchState;
}

const initialState = {
  addUserTourDeviationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useAddUserTourDeviationSlice: StateCreator<
  addUserTourDeviationInterface
> = (set, get) => ({
  ...initialState,
  addUserTourDeviation: async (payload: addUserTourDeviation.Params) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddUserTourDeviation = new RemoteAddUserTourDeviation(
      `${BASE_URL}${Endpoints.ADD_USER_TOUR_DEVIATION}`,
      axiosHttpClient
    );
    set({ addUserTourDeviationState: FetchState.LOADING });

    let result = await remoteAddUserTourDeviation.add(payload);
    return result;
  },
});
